const record = (v: unknown): Record<string, unknown> | null => v !== null && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : null;
export const UUID = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
export const isUuid = (v: unknown): v is string => typeof v === 'string' && UUID.test(v);

/** layer_list_entry_uuid(): item_layer_effect → items.item_id → item_id → a bare string; each cut at '|'. */
export function layerListEntryUuid(entry: unknown): string {
  const cut = (v: unknown): string => typeof v === 'string' && v !== '' ? v.split('|', 1)[0]! : '';
  const row = record(entry);
  if (row) return cut(row.item_layer_effect) || cut(record(row.items)?.item_id) || cut(row.item_id);
  return cut(entry);
}
/** ft_normalize_layer_entries_to_distinct_uuids(). PHP compares these case-sensitively (in_array strict). */
export function distinctUuids(entries: unknown[]): string[] {
  const out: string[] = [];
  for (const e of entries) { const id = layerListEntryUuid(e); if (id && isUuid(id) && !out.includes(id)) out.push(id); }
  return out;
}
